import { TOGGLE_MOBILE_SIDEBAR_EXPANDED } from '../constants';

export const doToggleMobileSidebarExpanded =
  ({ expanded = false }) =>
  ({ dispatch }) => {
    dispatch({ payload: { expanded }, type: TOGGLE_MOBILE_SIDEBAR_EXPANDED });
  };
